import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import { Content, Footer, SignUpPageStyled } from './SignUpPage.styled'
import { gapY } from '@mobi/component-library/Utils/gap'

export const PageLayout = styled(SignUpPageStyled)(gapY(spacing.bigx1))

export const Legend = styled.div(() => ({
  fontFamily: font.family.primary,
  ...font.size.lg,
  fontWeight: font.weight.medium,
  marginBottom: spacing.md,
}))

export const BoldStyled = styled.b({
  color: colors.studio[500],
})

export const FormSection = styled(Content)(gapY(spacing.sm))

export const CheckboxLabel = styled.div({
  margin: `${spacing.smx1} 0`,
  a: {
    color: colors.studio[500],
  },
  ...font.size.lg,
})

export const Caption = styled.span({
  color: colors.neutral[600],
  fontFamily: font.family.primary,
  margin: '1.2rem 0',
  ...font.size.md,
  a: {
    color: colors.studio[500],
  },
})

export const FooterStyled = styled(Footer)(gapY(spacing.bigx1))
